/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annually`)
};

const es_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anualmente`)
};

const de_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const nl_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijks`)
};

const fr_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuellement`)
};

const it_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annualmente`)
};

const pt_br2_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anualmente`)
};

const pt_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anualmente`)
};

const ja_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年1回`)
};

const zh_cp_freq_annually = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每年`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_freq_annually = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_freq_annually(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_freq_annually", locale)
	if (locale === "en") return en_cp_freq_annually(inputs)
	if (locale === "es") return es_cp_freq_annually(inputs)
	if (locale === "de") return de_cp_freq_annually(inputs)
	if (locale === "nl") return nl_cp_freq_annually(inputs)
	if (locale === "fr") return fr_cp_freq_annually(inputs)
	if (locale === "it") return it_cp_freq_annually(inputs)
	if (locale === "pt-BR") return pt_br2_cp_freq_annually(inputs)
	if (locale === "pt") return pt_cp_freq_annually(inputs)
	if (locale === "ja") return ja_cp_freq_annually(inputs)
	return zh_cp_freq_annually(inputs)
};